import { render, staticRenderFns } from "./FormSwitchItem.vue?vue&type=template&id=192aa2a4&"
import script from "./FormSwitchItem.vue?vue&type=script&lang=js&"
export * from "./FormSwitchItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports